export default "__VITE_ASSET__Czx8nWX___"